import { createAction, ActionType, createReducer } from 'typesafe-actions';

interface SearchbarReducer {
  update: boolean;
  value: string;
}

const initialState: SearchbarReducer = {
  update: false,
  value: '',
};

export const CLEAR_SEARCHBAR = 'SearchbarReducer/CLEAR_SEARCHBAR';
export const SET_SEARCHBAR = 'SearchbarReducer/SET_SEARCHBAR';
export const SET_VALUE = 'SearchbarReducer/SET_VALUE';
export const SET_UPDATE = 'SearchbarReducer/SET_UPDATE';

export const clearPath = createAction(CLEAR_SEARCHBAR)();
export const setSearchbar = createAction(SET_SEARCHBAR)<SearchbarReducer>();
export const setPath = createAction(SET_VALUE)<{ value: string }>();
export const setMoveTab = createAction(SET_UPDATE)<{ update: boolean }>();

export const actions = { setPath, setSearchbar, clearPath, setMoveTab };
type SearchbarReducerActions = ActionType<typeof actions>;

const SearchbarReducer = createReducer<SearchbarReducer, SearchbarReducerActions>(initialState, {
  [CLEAR_SEARCHBAR]: () => {
    return {
      update: false,
      value: '',
    };
  },
  [SET_SEARCHBAR]: (state, action) => {
    return {
      update: action.payload.update,
      value: action.payload.value,
    };
  },
  [SET_VALUE]: (state, action) => {
    return {
      ...state,
      value: action.payload.value,
    };
  },
  [SET_UPDATE]: (state, action) => {
    return {
      ...state,
      update: action.payload.update,
    };
  },
});

export default SearchbarReducer;
